import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Paper, List } from '@material-ui/core';

import Note from './Note';
import PostNote from './PostNote';
import i18n from '../../i18n';

import '../../assets/stylesheets/Notes.css';

class NotesContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newNoteDescription: ''
    };
  }

  getNoteOfLoggedInUser = () => {
    const { loggedInEmployeeId, notes } = this.props;
    const loggedInUserNote = notes.filter(
      note => note.authorStudioEmployeeId === loggedInEmployeeId
    );
    return loggedInUserNote.length > 0 ? loggedInUserNote[0] : false;
  };

  handleNoteChange = description => {
    this.setState({ newNoteDescription: description });
  };

  onSubmit = () => {
    const { newNoteDescription } = this.state;
    const { onNoteSubmit } = this.props;

    if (newNoteDescription !== '') {
      onNoteSubmit(newNoteDescription);
      this.setState({ newNoteDescription: '' });
    }
  };

  render() {
    const { newNoteDescription } = this.state;
    const { notes, onNoteDelete, updateNoteDescription } = this.props;
    const loggedInUserNote = this.getNoteOfLoggedInUser();
    return (
      <>
        <h4>{i18n.t('userProfile:yourNote')}</h4>
        {loggedInUserNote ? (
          <Paper className="notes-container">
            <List>
              <Note
                key={loggedInUserNote.id}
                note={loggedInUserNote}
                isEditable
                onDelete={onNoteDelete}
                isLoggedInUserNote={false} // Don't use custom style for notes in 'Your note' section
                updateNoteDescription={updateNoteDescription}
              />
            </List>
          </Paper>
        ) : (
          <PostNote
            description={newNoteDescription}
            handleNoteChange={this.handleNoteChange}
            onSubmit={this.onSubmit}
          />
        )}

        <h4>{i18n.t('userProfile:allNotes')}</h4>
        {notes.length === 0 ? (
          <p>{i18n.t('userProfile:noNotes')}</p>
        ) : (
          <Paper className="notes-container">
            <List dense>
              {_.reverse(_.sortBy(notes, ['updatedAt'])).map(note => (
                <Note
                  key={note.id}
                  note={note}
                  isEditable={false}
                  onDelete={onNoteDelete}
                  isLoggedInUserNote={
                    loggedInUserNote && note.id === loggedInUserNote.id
                  }
                  updateNoteDescription={updateNoteDescription}
                />
              ))}
            </List>
          </Paper>
        )}
      </>
    );
  }
}

NotesContainer.propTypes = {
  loggedInEmployeeId: PropTypes.number.isRequired,
  onNoteSubmit: PropTypes.func.isRequired,
  onNoteDelete: PropTypes.func.isRequired,
  updateNoteDescription: PropTypes.func.isRequired,
  notes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      createdAt: PropTypes.string,
      description: PropTypes.string,
      profileImage: PropTypes.string
    })
  )
};

NotesContainer.defaultProps = {
  notes: null
};

export default NotesContainer;
